import { styles } from '@src/components/Search/Navigate/Select/styles';
import React from 'react';
import Select from 'react-select';

const GCSEFilters = ({ filterControls, selectedGrades, onGradeChange }) => {
  if (!filterControls.gradeValues?.length) {
    return null;
  }

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '1rem',
        alignItems: 'center',
      }}
    >
      {filterControls.gradeValues?.length > 0 && (
        <div style={{ minWidth: '200px', maxWidth: '300px' }}>
          <Select
            isMulti
            options={filterControls.gradeValues.map((value) => ({
              value,
              label: `Grade ${value}`,
            }))}
            value={filterControls.gradeValues
              .filter((value) => selectedGrades.includes(value))
              .map((value) => ({ value, label: `Grade ${value}` }))}
            onChange={onGradeChange}
            placeholder="Select grades..."
            isClearable
            styles={styles}
          />
        </div>
      )}
    </div>
  );
};

export default GCSEFilters;
